import { render } from "./BlockInfo.vue?vue&type=template&id=eccfd0ae"
import script from "./BlockInfo.vue?vue&type=script&lang=js"
export * from "./BlockInfo.vue?vue&type=script&lang=js"

import "./BlockInfo.vue?vue&type=style&index=0&id=eccfd0ae&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__